module.exports = __webpack_public_path__ + "img/curv_19_a.e349bc8a.jpg";